/* eslint-disable */
import React from "react";
import { NewsWidget, NewsWidgetHeader, NewsWidgetColumn } from "../../components/NewsWidget";
import { NewsWidgetMore as More, NewsWidgetTitle as Title } from "../../components/NewsWidget/shared/NewsWidgetHeader";
import {
  NewsWidgetRow as Row,
  NewsWidgetDate as Date,
  NewsWidgetContent as Content,
} from "../../components/NewsWidget/shared/NewsWidgetColumn";
import { useNews } from "../../shared/hooks/useNews";
import moment from "moment";
import messages from "./messages";
import { FormattedMessage } from "react-intl";

export default () => {
  const [news] = useNews();

  // const newsForRender = news.sort((a, b) => moment(a.createdDate).diff(moment(b.createdDate))).reverse(); // news to be sorted at backend
  const countRowsInColumn = [0, 0, 0];

  return (
    <NewsWidget>
      <NewsWidgetHeader>
        <Title>
          <FormattedMessage {...messages.headerLabel} />
        </Title>
        <More to="/news">
          <FormattedMessage {...messages.headerMore} />
        </More>
      </NewsWidgetHeader>

      {news
        .map((n, indexNews) => {
          if (!(indexNews % countRowsInColumn.length)) {
            return (
              <NewsWidgetColumn key={n.id}>
                {countRowsInColumn.map((val, indexMaxRow) => {
                  const row = news[indexNews + indexMaxRow];
                  return (
                    row && (
                      <Row key={`${n.id}_${indexMaxRow}`}>
                        <Date>{moment(row.createdDate).format("MMMM DD, YYYY")}</Date>
                        <Content to={`/news?id=${row.id}`}>{row.caption}</Content>
                      </Row>
                    )
                  );
                })}
              </NewsWidgetColumn>
            );
          }
          return null;
        })
        .filter((val) => !!val)}
    </NewsWidget>
  );
};
